module.exports = __webpack_public_path__ + "img/gzw.3e33c3cf.jpg";